import * as yup from 'yup';

export const reviewSchema = yup.object().shape({
  storyViews: yup.number().required().min(0),
  linkFollowUps: yup.number().required().min(0),
});